//hook
import { useState, useEffect } from 'react';
import { UserConsumer } from '../hooks/context/UserContext';
import { useApi } from '../hooks/useApi';
import { useNavigate } from 'react-router-dom';


//component
import AuthDialog from '../Auth/AuthDialog';
import Otp from '../Auth/Otp';

//api
import { GetLogoutApi } from '../api/GetLogoutApi';

//mui
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';

//material ui icons
import LanguageIcon from '@mui/icons-material/Language';
import SettingsIcon from '@mui/icons-material/Settings';

//translate
import { useTranslation } from 'react-i18next';
// import i18n from '../translate/i18n';

//image
import gettak_logo from "../assets/header/gettak-logo.png"

//react router dom
import { useLocation, Link } from "react-router-dom";
import NotificationList from './NotificationList';

// 'my_drivers',
const pages = ['home', 'available_cars','cars_offers' ,'reservations', 'my_cars','my_claims', 'my_related_claims', 'about', 'contact', 'privacy_policy'];
const settings = ['profile', 'logout', 'language'];


const Header = () => {
  const location = useLocation();
  let {userData, setUserData, theme, setTheme} = UserConsumer()
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [openOtp, setOpenOtp] = useState(false);
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const token = localStorage.getItem("token")
  const visiblePages = 
  token && userData?.is_verified !== 0
  ? theme === "client" 
    ? pages.filter(page => page !== 'my_cars' && page !== 'my_drivers' && page !== 'my_claims') 
    : theme === "driver" 
      ? pages.filter(page => page !== 'home' && page !== 'available_cars' && page !== 'cars_offers' && page !== 'my_cars' && page !== 'my_drivers' && page !== 'my_claims') 
      : pages.filter(page => page !== 'home' && page !== 'available_cars' && page !== 'cars_offers' && page !== 'my_related_claims')
  : pages.filter(page => page !== 'reservations' && page !== 'my_cars' && page !== 'my_drivers' && page !== 'my_claims' && page !== 'my_related_claims' );

  const isActive = (pagePath: string) => {
    return location.pathname === pagePath;
  };
  
  const resolvePath = (page: string) => {
    if (page === "home") return "/client";
    if (page === "reservations") {
      if (theme === "host") return "/host";
      if (theme === "driver") return "/driver";
      return "/client/reservations";
    }
    if (["about", "contact", "privacy_policy"].includes(page)) {
      return `/${page}`;
    }
    return `/${theme}/${page}`;
  };

    const {
    loading: logoutLoading,
    error: logoutError,
    HandlerApi: logoutApi,
  } = useApi(GetLogoutApi, "GET");
  

  // start the translation way

  // change the lang on click
  const handleClick = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
  };
  // set default language only once
  useEffect(() => {
    const savedLang = localStorage.getItem("i18nextLng");
    const alreadyReloaded = localStorage.getItem("reloaded");
    const lang = savedLang ? savedLang.startsWith("en") ? "ar" : savedLang : "en";
    // i18n.changeLanguage(lang);
    if(!alreadyReloaded) {
      localStorage.setItem("reloaded", "true");
      i18n.changeLanguage(lang);
      window.location.reload();
    }
  }, []);

  // end the translation way

  //start functions

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    console.log("sdfkmsdlflsdfnsd")
    console.log(event.currentTarget)
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const handleLogout = async ()=>{
    let result = await logoutApi();
    if(result.code === 200){
      console.log("Logout successful:");
      setTheme("client")
      localStorage.removeItem("token");
      localStorage.removeItem("fcm_token");
      setUserData(null);
      setAnchorElUser(null);
      setAnchorElNav(null);
      navigate("/")
    }
  }

  //end functions

  return (
    <div>
      <AppBar position="fixed" className='!bg-white'>
        <Container maxWidth="xl">
          <Toolbar className="justify-between" disableGutters>
            {/* start more than 1200px */}
            <Box sx={{ display: { xs: 'none', lg: 'flex' }}} className='flex items-center'>
              <img className='w-[100px] h-[75px]' src={gettak_logo} alt='no=photo'/>
              {token
              ?
                <NotificationList/>
              :<></>
              } 
            </Box>
            <Box sx={{ flexGrow: 0, gap: "10px", display: { xs: 'none', lg: 'flex' }}}>
              {visiblePages.map((page) => {
                const path = resolvePath(page);
                const active = isActive(path);
                return (
                  <Link key={page} to={path}>
                    <Button
                      className={active ? theme === "client" ? '!bg-customerColor !text-white' : '!bg-paretnerColor !text-white' : ''}
                      sx={{ my: 2, color: 'black', display: 'block' }}
                    >
                      {t(page)}
                    </Button>
                  </Link>
                );
              })}

            </Box>
            {/* end more than 1200px */}
            
            {/* start less than 1200px */}
            <Box sx={{display: { xs: 'flex', lg: 'none' }, alignItems: "center" }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                className='!text-customerColor'
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{ display: { xs: 'block', lg: 'none' } }}
              >
              {visiblePages.map((page) => {
                const path = resolvePath(page);
                const active = isActive(path);
                return (
                  <Link key={page} to={path}>
                    <Button
                      className={active ? theme === "client" ? '!bg-customerColor !text-white' : '!bg-paretnerColor !text-white' : ''}
                      sx={{ my: 2, color: 'black', display: 'block' }}
                    >
                      {t(page)}
                    </Button>
                  </Link>
                );
              })}
              </Menu>
              {token
              ?
                <NotificationList/>
              :<></>
              } 
            </Box>
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="#app-bar-with-responsive-menu"
              sx={{
                display: { xs: 'flex', lg: 'none' },
              }}
            >
              <Box sx={{ width: "100%" }}>
                <img className='w-[100px] h-[75px]' src={gettak_logo} alt='no=photo'/>
              </Box>
            </Typography>
            {/* end less than 1200px */}

            
            <Box sx={{ display: "flex", flexWrap: "wrap"}}>
              <div>
                {token 
                ? 
                <>
                  <Tooltip title="Open settings">
                    <IconButton onClick={handleOpenUserMenu} sx={{ p: 0, gap: "10px" }}>
                      <Avatar alt={userData?.full_name} className={theme === "client" ? "!bg-customerColor" : "!bg-paretnerColor"} src="/static/images/avatar/2.jpg" />
                      <SettingsIcon className={theme === "client" ? "!text-customerColor" : "!text-paretnerColor"}/>
                    </IconButton>
                  </Tooltip>
                  <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                  >
                    {settings.map((setting) => (
                      setting === "language"
                      ?
                      <Button
                        onClick={handleClick}
                        key={setting}
                        className='!text-black'
                        style={{fontWeight: "bold"}}
                      >
                        <LanguageIcon fontSize="small" />
                        <span>{i18n.language === "ar" ? t("En") : t("Ar")}</span>
                      </Button>
                      :
                      setting === "logout"
                        ?
                        <MenuItem key={setting} onClick={handleLogout}>
                          <Typography sx={{ textAlign: 'center' }}>{t(setting)}</Typography>
                        </MenuItem>
                        :
                        <MenuItem key={setting} onClick={setting === "logout" ? handleLogout : handleCloseUserMenu}>
                          <Link to={`/${setting}`}>
                            <Typography sx={{ textAlign: 'center' }}>{t(setting)}</Typography>
                          </Link>
                        </MenuItem>
                    ))}
                  </Menu>

                </>
                :
                <div className='flex'>
                    <AuthDialog setOpenOtp = {setOpenOtp}/>
                </div>
                }
              </div>
              <Otp 
                openOtp = {openOtp} 
                setOpenOtp = {setOpenOtp}
              />
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  )
}

export default Header